export default __webpack_public_path__ + "img/2557b75d124a1aa023ff6bd7e8f8db5c.png";